import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, EXPORT_FILE_NAME } from './constants';

class AccountReceivableProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	async GetWarehouse(Ids: any) {
		return this.fetch('/DropdownList/GetWarehouse/', { WorkShopId: Ids });
	}

	async GetAccountReceivable(parameters: any, columnsSeq: any, languageId: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/${NAME}/GetAccountReceivableReport?${parameters}&ColumnSequence=${columnsSeq}&LanguageId=${languageId}`, EXPORT_FILE_NAME);
	}
}
export const apiProvider = new AccountReceivableProvider();
